import create from "zustand";

export const useFilterStore = create((set) => ({
  filterParams: {},
  setSearchTerm: (term) =>
    set((state) => {
      if (term.trim() === "") {
        const { search_term, ...rest } = state.filterParams;
        return { filterParams: rest };
      }
      return {
        filterParams: { ...state.filterParams, search_term: term.trim() },
      };
    }),
  setFilterParam: (key, value) =>
    set((state) => {
      if (value === undefined || value === "All") {
        const { [key]: _, ...updatedParams } = state.filterParams;
        return { filterParams: updatedParams };
      }
      return { filterParams: { ...state.filterParams, [key]: value } };
    }),
}));
